// @mui
import Button from '@mui/material/Button';
// localization
import { useLocales } from 'src/locales';
// types
import { ReturnType } from 'src/hooks/use-boolean';
// components
import { TaxRateDto } from 'src/api';
import { ConfirmDialog } from '../custom-dialog';
import { paths } from '../../routes/paths';

type props = {
  taxRates?: TaxRateDto[];
  openState: ReturnType;
};

export default function TaxAddDialog({ taxRates, openState }: props) {
  const { t } = useLocales();

  const handleDismiss = () => {
    openState.onFalse();
  };

  const handleAdd = () => {
    openState.onFalse();
    window.location.href = `${paths.bookkeeping.tax}`;
  };

  const renderConfirm = (
    <ConfirmDialog
      open={openState.value}
      onClose={() => handleDismiss()}
      title={t('Add VAT account')}
      content={
        <>
          {t(
            'There aren´t yet add any VAT brackets, please create at least one before continuing.'
          )}
        </>
      }
      action={
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            handleAdd();
          }}
        >
          {t('Add VAT')}
        </Button>
      }
    />
  );

  return renderConfirm;
}
